<template>
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M78.7803 139C111.543 139 138.102 112.422 138.102 79.636C138.102 46.8501 111.543 20.272 78.7803 20.272C46.018 20.272 19.459 46.8501 19.459 79.636C19.459 112.422 46.018 139 78.7803 139Z"
      fill="url(#paint0_linear_10083_74302)"
    />
    <mask
      id="mask0_10083_74302"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="19"
      y="20"
      width="128"
      height="119"
    >
      <path
        d="M103.334 133.331C95.7782 136.796 87.3695 138.728 78.5085 138.728C45.6429 138.728 19 112.15 19 79.364C19 46.5782 45.6429 20 78.5085 20C86.4022 20 93.9369 21.5332 100.83 24.3174H146.16L145.343 133.331H103.334Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_10083_74302)">
      <g filter="url(#filter0_d_10083_74302)">
        <path
          d="M15.6264 132.091C15.1252 132.091 14.7075 131.691 14.7075 131.211V86.0943C14.7075 85.6143 15.1252 85.2144 15.6264 85.2144H48.7887C49.2899 85.2144 49.7075 85.6143 49.7075 86.0943V131.211C49.7075 131.691 49.2899 132.091 48.7887 132.091H15.6264Z"
          fill="url(#paint1_linear_10083_74302)"
        />
      </g>
      <path
        opacity="0.24"
        d="M27.5431 96.3075C30.4966 94.5849 34.1269 94.615 37.0526 96.3863C39.9496 98.1937 41.7104 101.419 41.6941 104.889C41.6265 108.337 39.7385 111.577 37.3785 114.082C36.0164 115.534 34.4926 116.818 32.8384 117.908C32.7831 117.94 32.7261 117.969 32.6678 117.994C32.4255 118.098 32.1457 118.12 31.903 118.016C31.8536 117.995 31.8057 117.971 31.7595 117.943C29.2339 116.305 27.0182 114.215 25.2189 111.772C23.7134 109.733 22.858 107.27 22.769 104.717L22.7758 104.346C22.8987 101.013 24.6951 97.9685 27.5431 96.3075ZM33.458 101.868C32.2574 101.356 30.8731 101.634 29.9516 102.573C29.03 103.512 28.753 104.926 29.2498 106.156C29.7466 107.385 30.9193 108.187 32.2203 108.187C33.0726 108.193 33.8919 107.851 34.4956 107.235C35.0994 106.62 35.4374 105.784 35.4344 104.912C35.4389 103.582 34.6587 102.38 33.458 101.868Z"
        fill="url(#paint2_linear_10083_74302)"
      />
      <path
        opacity="0.14"
        d="M32.2326 122.174C35.9655 122.174 38.9916 121.567 38.9916 120.818C38.9916 120.068 35.9655 119.461 32.2326 119.461C28.4997 119.461 25.4736 120.068 25.4736 120.818C25.4736 121.567 28.4997 122.174 32.2326 122.174Z"
        fill="url(#paint3_linear_10083_74302)"
      />
      <g filter="url(#filter1_d_10083_74302)">
        <path
          d="M15.6264 76.8761C15.1252 76.8761 14.7075 76.4761 14.7075 75.9961V30.8797C14.7075 30.3997 15.1252 29.9998 15.6264 29.9998H48.7887C49.2899 29.9998 49.7075 30.3997 49.7075 30.8797V75.9961C49.7075 76.4761 49.2899 76.8761 48.7887 76.8761H15.6264Z"
          fill="url(#paint4_linear_10083_74302)"
        />
      </g>
      <path
        opacity="0.24"
        d="M27.5431 41.2176C30.4966 39.4951 34.1269 39.5252 37.0526 41.2965C39.9496 43.1039 41.7104 46.3296 41.6941 49.7995C41.6265 53.2467 39.7385 56.487 37.3785 58.992C36.0164 60.4443 34.4926 61.7285 32.8384 62.8184C32.7831 62.8504 32.7261 62.8791 32.6678 62.9041C32.4255 63.0083 32.1457 63.0298 31.903 62.9266C31.8536 62.9056 31.8057 62.881 31.7595 62.8528C29.2339 61.2152 27.0182 59.1249 25.2189 56.6824C23.7134 54.6435 22.858 52.1803 22.769 49.6272L22.7758 49.2557C22.8987 45.9232 24.6951 42.8787 27.5431 41.2176ZM33.458 46.7782C32.2574 46.2659 30.8731 46.5442 29.9516 47.4832C29.03 48.4221 28.753 49.8365 29.2498 51.066C29.7466 52.2954 30.9193 53.0973 32.2203 53.0973C33.0726 53.1035 33.8919 52.7608 34.4956 52.1456C35.0994 51.5305 35.4374 50.694 35.4344 49.8225C35.4389 48.4923 34.6587 47.2905 33.458 46.7782Z"
        fill="url(#paint5_linear_10083_74302)"
      />
      <path
        opacity="0.14"
        d="M32.2326 67.0846C35.9655 67.0846 38.9916 66.4771 38.9916 65.7277C38.9916 64.9784 35.9655 64.3708 32.2326 64.3708C28.4997 64.3708 25.4736 64.9784 25.4736 65.7277C25.4736 66.4771 28.4997 67.0846 32.2326 67.0846Z"
        fill="url(#paint6_linear_10083_74302)"
      />
      <g filter="url(#filter2_d_10083_74302)">
        <path
          d="M59.3588 132.091C58.8576 132.091 58.4399 131.691 58.4399 131.211V86.0943C58.4399 85.6143 58.8576 85.2144 59.3588 85.2144H92.5211C93.0223 85.2144 93.4399 85.6143 93.4399 86.0943V131.211C93.4399 131.691 93.0223 132.091 92.5211 132.091H59.3588Z"
          fill="url(#paint7_linear_10083_74302)"
        />
      </g>
      <path
        opacity="0.24"
        d="M71.2345 96.3072C74.188 94.5847 77.8183 94.6148 80.744 96.3861C83.641 98.1935 85.4018 101.419 85.3855 104.889C85.3179 108.336 83.4299 111.577 81.0699 114.082C79.7078 115.534 78.184 116.818 76.5298 117.908C76.4745 117.94 76.4175 117.969 76.3592 117.994C76.1169 118.098 75.8371 118.119 75.5944 118.016C75.545 117.995 75.4971 117.971 75.4509 117.942C72.9253 116.305 70.7096 114.214 68.9103 111.772C67.4048 109.733 66.5494 107.27 66.4604 104.717L66.4672 104.345C66.5901 101.013 68.3865 97.9683 71.2345 96.3072ZM77.1495 101.868C75.9488 101.355 74.5645 101.634 73.643 102.573C72.7214 103.512 72.4444 104.926 72.9412 106.156C73.438 107.385 74.6107 108.187 75.9117 108.187C76.764 108.193 77.5833 107.85 78.187 107.235C78.7908 106.62 79.1288 105.784 79.1258 104.912C79.1303 103.582 78.3501 102.38 77.1495 101.868Z"
        fill="url(#paint8_linear_10083_74302)"
      />
      <path
        opacity="0.14"
        d="M75.924 122.174C79.6569 122.174 82.683 121.567 82.683 120.818C82.683 120.068 79.6569 119.461 75.924 119.461C72.1911 119.461 69.165 120.068 69.165 120.818C69.165 121.567 72.1911 122.174 75.924 122.174Z"
        fill="url(#paint9_linear_10083_74302)"
      />
      <g filter="url(#filter3_d_10083_74302)">
        <path
          d="M59.3588 76.8761C58.8576 76.8761 58.4399 76.4761 58.4399 75.9961V30.8797C58.4399 30.3997 58.8576 29.9998 59.3588 29.9998H92.5211C93.0223 29.9998 93.4399 30.3997 93.4399 30.8797V75.9961C93.4399 76.4761 93.0223 76.8761 92.5211 76.8761H59.3588Z"
          fill="url(#paint10_linear_10083_74302)"
        />
      </g>
      <path
        opacity="0.24"
        d="M71.2345 41.2179C74.188 39.4953 77.8183 39.5254 80.744 41.2967C83.641 43.1041 85.4018 46.3298 85.3855 49.7998C85.3179 53.2469 83.4299 56.4873 81.0699 58.9922C79.7078 60.4445 78.184 61.7287 76.5298 62.8186C76.4745 62.8507 76.4175 62.8793 76.3592 62.9044C76.1169 63.0085 75.8371 63.03 75.5944 62.9268C75.545 62.9058 75.4971 62.8812 75.4509 62.8531C72.9253 61.2155 70.7096 59.1251 68.9103 56.6826C67.4048 54.6438 66.5494 52.1805 66.4604 49.6274L66.4672 49.256C66.5901 45.9234 68.3865 42.8789 71.2345 41.2179ZM77.1495 46.7784C75.9488 46.2661 74.5645 46.5445 73.643 47.4834C72.7214 48.4224 72.4444 49.8368 72.9412 51.0662C73.438 52.2956 74.6107 53.0976 75.9117 53.0976C76.764 53.1037 77.5833 52.761 78.187 52.1459C78.7908 51.5307 79.1288 50.6942 79.1258 49.8228C79.1303 48.4925 78.3501 47.2907 77.1495 46.7784Z"
        fill="url(#paint11_linear_10083_74302)"
      />
      <path
        opacity="0.14"
        d="M75.924 67.0846C79.6569 67.0846 82.683 66.4771 82.683 65.7277C82.683 64.9784 79.6569 64.3708 75.924 64.3708C72.1911 64.3708 69.165 64.9784 69.165 65.7277C69.165 66.4771 72.1911 67.0846 75.924 67.0846Z"
        fill="url(#paint12_linear_10083_74302)"
      />
      <g filter="url(#filter4_d_10083_74302)">
        <path
          d="M102.919 76.8761C102.418 76.8761 102 76.4761 102 75.9961V30.8797C102 30.3997 102.418 29.9998 102.919 29.9998H136.081C136.582 29.9998 137 30.3997 137 30.8797V75.9961C137 76.4761 136.582 76.8761 136.081 76.8761H102.919Z"
          fill="url(#paint13_linear_10083_74302)"
        />
      </g>
      <path
        opacity="0.24"
        d="M114.721 41.2171C117.686 39.4946 121.33 39.5247 124.267 41.296C127.175 43.1034 128.942 46.3291 128.926 49.799C128.858 53.2462 126.963 56.4866 124.594 58.9915C123.227 60.4438 121.697 61.728 120.036 62.8179C119.98 62.8504 119.922 62.8794 119.863 62.9048C119.621 63.0078 119.342 63.0291 119.1 62.9272C119.05 62.906 119.001 62.881 118.954 62.8523C116.418 61.2147 114.194 59.1244 112.388 56.6819C110.877 54.643 110.019 52.1798 109.929 49.6267L109.936 49.2553C110.059 45.9227 111.862 42.8782 114.721 41.2171ZM120.658 46.7777C119.453 46.2654 118.064 46.5437 117.139 47.4827C116.214 48.4217 115.936 49.8361 116.434 51.0655C116.933 52.2949 118.11 53.0968 119.416 53.0968C120.272 53.103 121.094 52.7603 121.7 52.1451C122.306 51.53 122.645 50.6935 122.642 49.822C122.647 48.4918 121.864 47.29 120.658 46.7777Z"
        fill="url(#paint14_linear_10083_74302)"
      />
      <path
        opacity="0.14"
        d="M119.429 67.0841C123.175 67.0841 126.213 66.4766 126.213 65.7273C126.213 64.9779 123.175 64.3704 119.429 64.3704C115.682 64.3704 112.644 64.9779 112.644 65.7273C112.644 66.4766 115.682 67.0841 119.429 67.0841Z"
        fill="url(#paint15_linear_10083_74302)"
      />
      <rect
        opacity="0.6"
        x="102"
        y="85.0796"
        width="35"
        height="46.8763"
        rx="2"
        fill="url(#paint16_linear_10083_74302)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.903 102.881C119.408 102.881 119.817 103.306 119.817 103.831V113.615C119.817 114.14 119.408 114.565 118.903 114.565C118.398 114.565 117.988 114.14 117.988 113.615V103.831C117.988 103.306 118.398 102.881 118.903 102.881Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M113.278 108.723C113.278 108.198 113.688 107.773 114.193 107.773H123.691C124.196 107.773 124.605 108.198 124.605 108.723C124.605 109.247 124.196 109.673 123.691 109.673H114.193C113.688 109.673 113.278 109.247 113.278 108.723Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10083_74302"
        x="-7.29248"
        y="74.2144"
        width="79"
        height="90.8762"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74302"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74302"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74302"
        x="-7.29248"
        y="18.9998"
        width="79"
        height="90.8762"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74302"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74302"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10083_74302"
        x="36.4399"
        y="74.2144"
        width="79"
        height="90.8762"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74302"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74302"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_10083_74302"
        x="36.4399"
        y="18.9998"
        width="79"
        height="90.8762"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74302"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74302"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_10083_74302"
        x="72"
        y="18.9998"
        width="79"
        height="90.8762"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-8" dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74302"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74302"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74302"
        x1="19.4571"
        y1="138.999"
        x2="138.186"
        y2="20.3559"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74302"
        x1="32.1961"
        y1="84.1301"
        x2="32.1961"
        y2="132.596"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74302"
        x1="22.7687"
        y1="118.103"
        x2="45.3915"
        y2="99.5429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74302"
        x1="25.4734"
        y1="122.174"
        x2="26.5208"
        y2="116.957"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74302"
        x1="32.1961"
        y1="28.9155"
        x2="32.1961"
        y2="77.3814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_74302"
        x1="22.7687"
        y1="63.0136"
        x2="45.3915"
        y2="44.453"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_74302"
        x1="25.4734"
        y1="67.0846"
        x2="26.5208"
        y2="61.8673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_74302"
        x1="75.9285"
        y1="84.1301"
        x2="75.9285"
        y2="132.596"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10083_74302"
        x1="66.4602"
        y1="118.103"
        x2="89.0829"
        y2="99.5426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10083_74302"
        x1="69.1648"
        y1="122.174"
        x2="70.2122"
        y2="116.957"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10083_74302"
        x1="75.9285"
        y1="28.9155"
        x2="75.9285"
        y2="77.3814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10083_74302"
        x1="66.4602"
        y1="63.0138"
        x2="89.0829"
        y2="44.4533"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10083_74302"
        x1="69.1648"
        y1="67.0846"
        x2="70.2122"
        y2="61.8673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10083_74302"
        x1="119.489"
        y1="28.9155"
        x2="119.489"
        y2="77.3814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10083_74302"
        x1="109.929"
        y1="63.0131"
        x2="132.568"
        y2="44.369"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10083_74302"
        x1="112.644"
        y1="67.0841"
        x2="113.688"
        y2="61.8653"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10083_74302"
        x1="101.999"
        y1="131.956"
        x2="146.944"
        y2="98.3978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
